import { gsap } from 'gsap';
import { lenis, xl } from '../common.js';
import { isElementInViewport } from '../lib/isElementInViewport.js';

// sorry for all that crap =)

function initMobileAccordion(accordionElement) {
  const details = [
    ...accordionElement.querySelectorAll('.horizontal-accordion__details'),
  ];

  const handleMouseClick = (e) => {
    const summary = e.currentTarget;
    const detail = summary.parentElement;

    if (detail.classList.contains('is-open')) return;

    const idx = details.indexOf(detail);

    for (let i = 0; i < details.length; i++) {
      const d = details[i];
      if (i === idx) {
        d.classList.add('is-open');
      } else {
        d.classList.remove('is-open');
      }
    }

    setTimeout(() => {
      if (!isElementInViewport(summary)) {
        lenis.scrollTo(summary, {
          offset: -60,
          lerp: null,
          duration: 1,
        });
      }
    }, 10);
  };

  let summaries = [];
  details.forEach((detail, i) => {
    const summary = detail.querySelector('.horizontal-accordion__summary');
    summary.addEventListener('click', handleMouseClick);
    summaries.push(summaries);
  });

  return {
    destroy: () => {
      summaries.forEach((summary) => {
        summary.removeEventListener('click', handleMouseClick);
      });
    },
  };
}

function initDesktopAccordion(accordionElement) {
  const details = [
    ...accordionElement.querySelectorAll('.horizontal-accordion__details'),
  ];
  const gridColumns = 12;
  const openedColumnsSize = gridColumns - details.length;

  const updateInnerWidths = () => {
    details.forEach((detail) => {
      const rect = detail.getBoundingClientRect();
      const width = Math.round(rect.width);
      if (detail.classList.contains('is-open')) {
        accordionElement.style.setProperty('--opened-width', `${width}px`);
      } else {
        accordionElement.style.setProperty('--collapsed-width', `${width}px`);
      }
    });
  };

  const resize = (idx) => {
    let grid = [];

    for (let i = 0; i < details.length; i++) {
      const d = details[i];
      if (i === idx) {
        grid.push(`minmax(0, 880fr)`);
        d.classList.add('is-open');
      } else {
        grid.push('minmax(0, 100fr)');
        d.classList.remove('is-open');
      }
    }
    accordionElement.style.setProperty('--grid', grid.join(' '));
  };
  resize(0);

  const handleMouseEnter = (e) => {
    const detail = e.target;

    if (detail.classList.contains('is-open')) return;
    const idx = details.indexOf(detail);
    resize(idx);
  };

  details.forEach((detail, i) => {
    detail.addEventListener('mouseenter', handleMouseEnter);
  });

  window.addEventListener('resize', updateInnerWidths);
  setTimeout(() => updateInnerWidths(), 50);

  return {
    destroy: () => {
      window.removeEventListener('resize', updateInnerWidths);
      details.forEach((detail) => {
        const body = detail.querySelector('.horizontal-accordion__body');
        gsap.set(body, { clearProps: true });
        detail.removeEventListener('mouseenter', handleMouseEnter);
      });
    },
  };
}

export function initHorizontalAccordions(
  selector = '.js-horizontal-accordion',
) {
  const mm = gsap.matchMedia();
  mm.add(`(max-width: ${xl - 1}px)`, () => {
    const accordions = [...document.querySelectorAll(selector)].map((el) =>
      initMobileAccordion(el),
    );
    return () => {
      accordions.forEach((accordion) => accordion.destroy());
    };
  });

  mm.add(`(min-width: ${xl}px)`, () => {
    const accordions = [...document.querySelectorAll(selector)].map((el) =>
      initDesktopAccordion(el),
    );
    return () => {
      accordions.forEach((accordion) => accordion.destroy());
    };
  });
}
